/**
 * Business logic per Activities autocomplete
 * Pura - senza dipendenze da Vue
 */

import { isArray } from 'lodash-es';
import activitiesService from '../services/activitiesService';
import type { ActivityAutocompleteResult } from '../models/activity';
import type { ODataQueryBuilder } from './types';
import type { ODataContext } from '~/mixins/filterHandler/types';

export interface ActivitiesAutocompleteOptions {
	searchString?: string;
	id?: number | string | null;
	notInIds?: Array<number | string> | null;
	orderId?: number | string | null;
}

export async function getActivitiesAutocomplete(
	buildQuery: ODataQueryBuilder,
	options: ActivitiesAutocompleteOptions = {},
): Promise<ActivityAutocompleteResult[]> {
	const { searchString = '', id = null, notInIds = null, orderId = null } = options;

	const context: ODataContext = {
		select: 'id,code,description',
		count: true,
		top: 20,
		orderBy: ['code'],
		filter: { and: [] },
	};

	if (searchString !== '') {
		context.filter!.and!.push({
			or: [
				{ 'tolower(code)': { contains: searchString } },
				{ 'tolower(description)': { contains: searchString } },
			],
		});
	} else if (id) {
		context.filter!.and!.push({ id: { eq: id } });
	}

	if (orderId) {
		context.filter!.and!.push({
			orders: {
				any: {
					jobOrderId: orderId,
				},
			},
		});
	}

	if (notInIds && isArray(notInIds) && notInIds.length > 0) {
		context.filter!.and!.push({
			not: [{ id: { in: notInIds } }],
		});
	}

	const result = await activitiesService.getActivities(buildQuery(context));
	// OData select: id, code, description - type safety garantita da Pick<>
	return result.value;
}
